import React from 'react';
import classnames from 'classnames';
import DatePanel from './DatePanel';
import PropTypes from 'prop-types';
import { DateUtil } from '../util';

class WeekPanel extends React.Component{

    getRowClassName = date => {
        const { selectedDate } = this.props;
        return classnames({
            'picker-week-panel-row': true,
            'picker-week-panel-row-selected': DateUtil.isSame(date, selectedDate, 'week'),
        });
    }

    prefixColumn = date => {
        return (
            <td className="picker-cell-week">
                {DateUtil.getWeek(date)}
            </td>
        );
    }

    handleWeekSelect = (date, event) => {
        const { onChange, picker, onSelect } = this.props;
        onSelect?.(date, 'week');
        if(picker === 'week'){
            onChange?.(date, event);
        }
    }

    render(){
        const { onChange, onSelect, ...others } = this.props;
        return (
            <DatePanel
                {...others}
                className="picker-week-panel"
                getRowClassName={this.getRowClassName}
                prefixColumn={this.prefixColumn}
                onSelect={this.handleWeekSelect}
            />
        );
    }
}

WeekPanel.propTypes = {
    picker: PropTypes.string,
    selectedDate: PropTypes.object,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
};

export default WeekPanel;